<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="closable"
  [style]="{ width: width }"
  [contentStyle]="{ padding: '0' }"
  [dismissableMask]="false"
  [draggable]="false"
  [resizable]="false"
  [baseZIndex]="10000"
  (onHide)="onHide()"
>
    <div class="fd-wrapper">
        <div class="fd-body">
            <div class="fd-icon-wrapper" [ngClass]="iconWrapperClass" [ngStyle]="{width: iconCircle + 'px', height: iconCircle + 'px'}">
                <i [class]="icon" [ngStyle]="{ fontSize: iconSize + 'px' }"></i>
            </div>
            <h3 class="fd-title">{{ title }}</h3>
            <p class="fd-message">{{ message }}</p>
        </div>
        <div class="fd-footer">
            @if (showCancel) {
                <button pButton type="button" class="p-button-outlined fd-btn-cancel" [label]="cancelLabel" (click)="onCancelClick()"></button>
            }
            <button pButton type="button" class="fd-btn-confirm" [label]="confirmLabel" (click)="onConfirmClick()" [severity]="buttonSeverity"></button>
        </div>
    </div>
</p-dialog>
